export const setBodyScriptHTML = (body) => {
    return `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1.0"><link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous"><title>Document</title><style>p {font-size: 16px;}</style></head><body>${body}</body></html>`
}

export const cutText = (text = "", maxLength) => {
    if(text === "") return "";
    if(text.length > maxLength) return text.substring(0, maxLength) + "...";

    return text;
}